import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Typography, AppBar, Tabs, Tab, FormControlLabel, Checkbox } from '@mui/material'
import { Grid, Box } from '@mui/material';
import NavigationButtons from '../container/NavigationButtons';
// import dateFormat from 'dateformat'
import MDTextField from './custom/MDTextField';
import Person from './custom/Person';
import Address from './custom/Address';

function TabContainer({ children, dir }) {
  return (
    <Box>
    <Typography component="div" dir={dir} sx={{ p: 2 }}>
      {children}
    </Typography>
    </Box>
  );
}

function MailShip(props) {
  const dispatch = useDispatch()
  const activeStep = useSelector((state) => state.activeStep)
  const initialMailship = useSelector((state) => state.mailship)
  const initialAddresses = useSelector((state) => state.addresses)
  const person = useSelector((state) => state.person)

  const [mailship, setMailShip] = useState(initialMailship);
  const [addresses, setAddresses] = useState(initialAddresses)

  const [value, setValue] = useState(mailship.sendOrReceive === -1? 0 : mailship.sendOrReceive);
  const [summary, setSummary] = useState(false);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [business, setBusiness] = useState(false);

  const [requiredFields, setRequiredFields] = useState({shipDate: false, receiveDate: false, person: false, address3: false, mailshiplocator:''});

  useEffect(() => {
    setMailShip(initialMailship)
  }, [initialMailship])
  useEffect(() => {
    setAddresses(initialAddresses)
  }, [initialAddresses])
  // constructor(props) {
  //   super(props);
  //   this.state = {activeStep: props.activeStep, mailship: props.mailship, updatePerson: props.updatePerson, person: props.person, addresses: props.addresses,
  //                   value: props.mailship.sendOrReceive === -1? 0 : props.mailship.sendOrReceive, summary: false, error: false, errorText: '', business: false,          
  //                   requiredFields: {shipDate: false, receiveDate: false, person: false, address3: false, mailshiplocator:''}};
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props !== nextProps) {
  //     const { mailship } = this.state
  //     // console.log(JSON.stringify(mailship) + ' mailshipchange ' + JSON.stringify(nextProps.mailship))
  //     // if (nextProps.person != person) {
  //     //   this.setState({ person: nextProps.person });
  //     // }
  //     if (nextProps.mailship !== mailship) {
  //       this.setState({ mailship: nextProps.mailship });
  //     }
  //   }
  // }

  const handleChange = (propertyName, value) => {  
    const newMailShip = {
      ...mailship,
      [propertyName]: value,
    };

    // dispatch( updateMailShip(newMailShip) )
    setMailShip(newMailShip)
  }

  const handleTabChange = (event, value) => {
    const newMailShip = {
      ...mailship,
      sendOrReceive: value
    }

    let newRequiredFields;
    if (value === 1) {      
      if (mailship.receiveDate === '') {
        newRequiredFields = {
          ...requiredFields,
          receiveDate: false,
          shipDate: true,                
        };
      } else {
        newRequiredFields = {
          ...requiredFields,
          receiveDate: true,
          shipDate: true,                
        };
      }
      setRequiredFields(newRequiredFields)
    } else if (value === -1 || value === 0) {
      if (mailship.shipDate === '') {
        newRequiredFields = {
          ...requiredFields,          
          shipDate: false,
          receiveDate: true,      
        };
      } else {
        newRequiredFields = {
          ...requiredFields,          
          shipDate: true,
          receiveDate: true,      
        };
      }
      setRequiredFields(newRequiredFields)   
    }

    setValue(value)
    setMailShip(newMailShip)
    // dispatch( updateMailShip(newMailShip) )
  };

  const updatePerson = (person) => {
    setMailShip(person)
    // dispatch(updateMailShip(person))
  } 

  const updateAddresses = (address, index) =>  {
    const newAddresses = {...addresses}

    newAddresses[index] = address      

    setAddresses(newAddresses)
    // dispatch( updateAddress(newAddresses) )   
  }

  const handleError = (propertyName, error) => {

      if (propertyName === 'shipDate' || propertyName === 'receiveDate') {
        error = !error
      }

      let newRequiredFields = {
        ...requiredFields,
        [propertyName]: error,      
      };

      if (value === 1) {
        newRequiredFields = {
          ...newRequiredFields,
          shipDate: true,                
        };
      } else if (value === -1 || value === 0) {
        newRequiredFields = {
          ...newRequiredFields,          
          receiveDate: true,      
        };
      }
      // console.log('shprcv err ' + JSON.stringify(newRequiredFields))
      setRequiredFields(newRequiredFields)  
  }

  const handleChangeChecked = propertyName => event => {  
    setBusiness(event.target.checked) 
  }

  return (
    <div>        
            <Grid>
                <AppBar position="relative" color="inherit" sx={{
                  padding: 2,
                  textAlign: 'left',
                  justifyContent: 'center',
                  color: 'text.primary',
                  backgroundColor: '#ffffff',
                }} >
                  <Tabs
                    value={value}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="black"
                    variant="fullWidth"
                  >
                    <Tab sx={{
                      minHeight: '30px',
                      backgroundColor: (value === -1 || value === 0) ? "#4D95A3" : '#07444a63',
                      color: (value === -1 || value === 0) ? "inherit" : "inherit",
                      fontWeight: (value === -1 || value === 0) ? "760" : "normal"
                    }} label="Shipping" />
                    <Tab sx={{
                      minHeight: '30px',
                      backgroundColor: value === 1 ? "#4D95A3" : '#07444a63',
                      color: value === 1 ? "inherit" : "inherit",
                      fontWeight: value === 1 ? "760" : "normal"
                    }} label="Receiving" />
                  </Tabs>                  
                
                <TabContainer>
                  <FormControlLabel
                    sx={{ ml: 1 }}
                    control={
                    <Checkbox
                      checked={business ? true: false}
                      onChange={handleChangeChecked()}
                      value={business}
                    /> }
                    label="Business"
                  />

                    <Person person={mailship} mailshiplocator='mailship' updatePerson={updatePerson} handleError={handleError} shiprecv={true} business={business} inputLabelProps={{ shrink: true }} />
                    <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>
                    {(value === -1 || value === 0) &&
                    <MDTextField name='shipDate'  mailshiplocator='mailship' label='Date Shipped' value={mailship.shipDate} type='date' inputLabelProps={{ shrink: true }} handleChange={handleChange} 
                        handleError={handleError} required={true} summary={summary} />
                    }
                    {value === 1 &&
                    <MDTextField name='receiveDate'   mailshiplocator='mailship'label='Date Received' value={mailship.receiveDate} type='date' inputLabelProps={{ shrink: true }} handleChange={handleChange} 
                        handleError={handleError} required={true} summary={summary} error={error !== false? error : undefined} errorText={errorText !== ''? errorText : undefined} />
                    }
                    <MDTextField name='methodOfShipment' label='Method of Shipment' mailshiplocator='mailship' value={mailship.methodOfShipment} handleChange={handleChange} 
                        handleError={handleError} required={false} inputProps={{ maxLength: 15, }} summary={summary} />
                    <MDTextField name='carrierName' label='Carrier Name' mailshiplocator='mailship' value={mailship.carrierName} handleChange={handleChange} 
                        handleError={handleError} required={false} inputProps={{ maxLength: 95, }} summary={summary} />
                    </Grid>
                    <Grid>
                    <Typography sx={{
                      mr: 2,
                      fontSize: '0.9375rem',
                      color: 'text.primary',
                      pt: 4,
                      mb: 0,
                      fontWeight: "660"
                    }}>{value === -1 || value === 0? "Shipper's Address" : "Receiver's Address"}</Typography>
                  </Grid>
                    <Address address={addresses[3]} index='3'  updateAddress={updateAddresses}  handleError={handleError} /> 
                </TabContainer>                
            </AppBar>                  
          </Grid>        

            <NavigationButtons mailship={mailship} mailshipPerson={person} addresses={addresses} 
                  allReqDone={       
                  requiredFields.address3 && !error && requiredFields.shipDate && requiredFields.receiveDate && requiredFields.person
          } />
      </div>
  );
}

export default MailShip;